module.exports = __webpack_public_path__ + "static/media/export-pdf.ccb73b45.svg";